import { InvalidNumberError } from '../errors';

export enum AdjustmentOperationBasic {
  adding = 'Adding',
  subtracting = 'Subtracting',
  multiplyingBy = 'Multiplying By',
  dividingBy = 'Dividing By',
  modulo = 'Computing the Modulo With'
}

/**
 * Parse a value of unknown type as a number or return undefined if the value is non-numeric.
 * @param value The value to parse as a number.
 */
export function parseNumber(value: unknown): number | undefined {
  if (typeof value === 'number') {
    return value;
  }

  if (typeof value !== 'string') {
    return undefined;
  }

  const numericValue = Number(value);
  if (isNaN(numericValue)) {
    return undefined;
  }
  return numericValue;
}

/**
 * Parse a value of unknown type as a number or throw an error if the value is non-numeric.
 * @param value The value to parse as a number.
 * @param inputName The name of the variable/property from which the value was obtained.
 */
export function parseNumberOrThrow(value: unknown, inputName: string): number {
  const numericValue = parseNumber(value);
  if (numericValue === undefined) {
    throw new InvalidNumberError(inputName);
  }
  return numericValue;
}
